var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsObject, IsString, IsUUID } from 'class-validator';
import { OfficeLocationStub, } from '../../offices/index.js';
import { OfficeLiteDto } from '../../offices/dto/office.lite.dto.js';
import { FeatureToggleType } from '../enums/feature-toggle-type.enum.js';
export class FeatureToggleFullSizeDto {
    id;
    createdAt;
    updatedAt;
    type;
    isEnabled;
    officeLocationId;
    officeId;
    officeLocation;
    office;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], FeatureToggleFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], FeatureToggleFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], FeatureToggleFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsEnum(FeatureToggleType),
    Expose(),
    __metadata("design:type", String)
], FeatureToggleFullSizeDto.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], FeatureToggleFullSizeDto.prototype, "isEnabled", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], FeatureToggleFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], FeatureToggleFullSizeDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => OfficeLocationStub),
    __metadata("design:type", Function)
], FeatureToggleFullSizeDto.prototype, "officeLocation", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => OfficeLiteDto),
    __metadata("design:type", Function)
], FeatureToggleFullSizeDto.prototype, "office", void 0);
//# sourceMappingURL=feature-toggle.full-size.dto.js.map